import React, { useState, useCallback, useEffect } from 'react';
import _ from 'lodash';
var QRCode = require('qrcode.react');
import getParameterByName from '../../utils/getParameterByName';
import { getDynamicCanvasContent } from '../../modules/dynamicCanvas';

import './report.css';
const loadingImageSrc =
  'data:image/svg+xml;base64,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';

const ShareReportModal = function (props) {
  const chart = props.chart;
  const [imgUrl, setImgUrl] = useState(null);

  // const shareQRCodeUrl = `${window.__shareUrl}&from=chartqrcode`;

  // console.log('shareQRCodeUrl', shareQRCodeUrl);

  useEffect(() => {
    async function getCanvasBase64() {
      const shareQRCodeUrl = `${window.__shareUrl}&from=chartqrcode`;
      console.log('shareQRCodeUrl', shareQRCodeUrl);

      console.log({
        backgroundImage: props.reportBackgroundUrl,
        addOnList: props.reportConfig,
        shareQRCodeUrl
      });
      let canvasBase64 = await getDynamicCanvasContent({
        backgroundImage: props.reportBackgroundUrl,
        addOnList: props.reportConfig,
        shareQRCodeUrl
      });

      setImgUrl(canvasBase64);
    }

    getCanvasBase64();
  }, [props]);

  // useEffect(() => {
  //   if (!props.chart) return;

  //   let canvas = document.createElement('canvas');

  //   const ctx = canvas.getContext('2d');

  //   var image = new Image();
  //   image.crossOrigin = 'anonymous';
  //   image.onload = function() {
  //     const score = _.get(props, 'chart.data[0].value', '--');
  //     const rootTid = localStorage.getItem('rootTid');
  //     console.log('rootTid: ', rootTid);
  //     // draw image...
  //     canvas.width = image.width;
  //     canvas.height = image.height;
  //     ctx.drawImage(image, 0, 0);

  //     let emoji = '';
  //     if (score > 52) {
  //       emoji = '😣';
  //     } else if (score > 28) {
  //       emoji = '😔';
  //     } else {
  //       emoji = '😄';
  //     }
  //     // draw emoji
  //     ctx.font = '70px Arial';
  //     ctx.textAlign = 'center';
  //     ctx.fillText(emoji, canvas.width / 2, 1110);

  //     // write score
  //     ctx.font = '700 250px Arial ';
  //     ctx.fillStyle = 'white';
  //     ctx.textAlign = 'center';
  //     ctx.fillText(score, canvas.width / 2, 1320);

  //     //put qrcode onto it
  //     let qrcodeDom = document.getElementById('share_report_modal_qrcode');
  //     ctx.drawImage(qrcodeDom, 110, 1557, 200, 200);

  //     //write rootTid below qr code
  //     ctx.font = '12px Arial';
  //     ctx.fillStyle = 'white';
  //     ctx.textAlign = 'left';
  //     ctx.fillText(rootTid, 10, 1840);

  //     // draw pointer

  //     // draw the pointer
  //     const pointer = new Path2D();
  //     const POINTER_X = canvas.width / 2;
  //     const POINTER_Y = 700;
  //     pointer.moveTo(POINTER_X + 0, POINTER_Y - 20);
  //     pointer.lineTo(POINTER_X + 10, POINTER_Y + 0);
  //     pointer.lineTo(POINTER_X + 0, POINTER_Y + 90);
  //     pointer.lineTo(POINTER_X - 10, POINTER_Y + 0);
  //     pointer.lineTo(POINTER_X - 0, POINTER_Y - 20);

  //     // rotate the pointer to the start point
  //     ctx.translate(POINTER_X, POINTER_Y); // first, translate the axis to the center of the pointer
  //     ctx.rotate((39 / 180) * Math.PI); // rotate to the start position

  //     const FULL_ANGLE = 285;

  //     ctx.rotate((((score / 100) * FULL_ANGLE) / 180) * Math.PI); // rotate to the score position
  //     //   ctx.stroke(pointer);
  //     ctx.translate(-POINTER_X, -POINTER_Y);
  //     ctx.fill(pointer);

  //     // export image
  //     var mediumQuality = canvas.toDataURL('image/png', 0.5);
  //     setImgUrl(mediumQuality);
  //   };
  //   // image.src = '///image.siuvo.com.cn/wechat/nCovShareEmpty_1_31.png';
  //   image.src =
  //     getParameterByName('lang') === 'tc'
  //       ? '///image.siuvo.com.cn/wechat/nCovShareEmpty_1_31_tc.png'
  //       : '///image.siuvo.com.cn/wechat/nCovShareEmpty_1_31.png';
  // }, [props, props.chart]);

  // if (!chart) {
  //   return null;
  // }

  return (
    <div
      className="modal-image"
      style={{
        backgroundColor: '#ffffff77',
      }}
    >
      <img
        src={imgUrl || loadingImageSrc}
        style={{ width: '100%', display: 'block' }}
      ></img>

      <div
        style={{ marginTop: 30, color: 'white', marginBottom: 10 }}
        className="element-animation"
      // className="element-animation"
      >
        {getParameterByName('lang') === 'tc'
          ? '⬆️ 長按圖片保存或分享'
          : '⬆️ 长按图片保存或分享'}
      </div>

      {/* {imgUrl ? (
        <div
          style={{
            padding: 10,
            margin: 10,
            backgroundColor: '#2979ff',
            color: 'white',
            borderRadius: 10
          }}
          onClick={() => {
            var a = document.createElement('a');
            a.href = imgUrl;
            a.download = 'image.png';

            a.click();
          }}
        >
          保存到本地
        </div>
      ) : null} */}
    </div>
  );
};
ShareReportModal.defaultProps = {
  reportConfig: [],
  reportBackgroundUrl: ''
};
export default ShareReportModal;
